/* eslint-disable react/no-unused-state */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import TopPanel from '../../utils/TopPanel';
import PhotoWidget from '../../utils/FormWidgets/PhotoWidget';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { getBase64 } from '../../../infrastructure/utils/common';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import EntertainmentList from './EntertainmentList';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Modal from '../../utils/ModalComponet';
import '../../../styles/containers/Parties.css';

class Entertainment {
  picture = '';
  title = '';
}

class State {
  entertainment = new Entertainment();
  editForm = false;
  update = false;
  entertainmentForDeleted = '';
  openModal = false;
  isError = false;
  modalContent = () => '';
  errorText = 'You can upload only png or jpg files';
}

export default class EntertainmentScreen extends React.Component {
  state = new State();

  toDelete = id => {
    this.setState({
      openModal: true,
      entertainmentForDeleted: id,
      modalContent: this.renderDeleteMessage,
      modalAction: this.deleteEntertainment,
      modalActionText: 'Delete',
    });
  };

  deleteEntertainment = async () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions, changeState, entertainments } = this.props;
    const { entertainmentForDeleted } = this.state;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    await actions.deleteEntertainment(entertainmentForDeleted);
    changeState({
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      entertainments: entertainments.filter(
        ent => ent.id !== entertainmentForDeleted
      ),
    });
    this.setState({ openModal: false });
  };

  toUpdate = id => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { entertainments } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const elem = entertainments.find(ent => ent.id === id);
    this.setState({
      openModal: true,
      update: true,
      modalContent: this.renderEntertainmentForm,
      modalAction: undefined,
      entertainment: {
        ...elem,
        picture: { ...elem.picture, isNew: false, data: elem.picture.data },
      },
    });
  };

  create = () => {
    this.setState({
      openModal: true,
      update: false,
      modalContent: this.renderEntertainmentForm,
      modalAction: undefined,
      entertainment: new Entertainment(),
    });
  };

  iconChange = async event => {
    const { target } = event;
    if (target.files.length === 0) {
      return;
    }
    if (
      target.files[0].type !== 'image/png' &&
      target.files[0].type !== 'image/jpeg'
    ) {
      this.setState({ isError: true });
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      setTimeout(this.hideMessage, 5 * 1000);
      return;
    }
    const icon = await getBase64(target.files[0]);
    this.setState(prevState => {
      const entertainment = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.entertainment,
        picture: {
          isNew: true,
          blob: target.files[0],
          data: icon,
        },
      };
      return { entertainment };
    });
  };

  titleChange = ({ target }) => {
    this.setState(prevState => {
      const entertainment = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.entertainment,
        title: target.value,
      };
      return { entertainment };
    });
  };

  createElement = (onlyOne = true) => {
    let { entertainment } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { addEntertainment } = this.props;
    entertainment = {
      ...entertainment,
      title: entertainment.title.trim(),
    };
    this.setState({
      entertainment: !onlyOne ? new Entertainment() : entertainment,
      openModal: !onlyOne,
    });
    addEntertainment(entertainment);
  };

  createAndAddElse = () => this.createElement(false);

  closeModal = () => {
    this.setState({ openModal: false });
  };

  renderEntertainmentForm = () => {
    const { update, entertainment } = this.state;
    const text = update ? 'Edit Entertainment' : 'Create Entertainments';
    const buttonText = update ? 'Update' : 'Create';
    return (
      <Fragment>
        <h4 className='modal-head'>{text}</h4>
        <div className='media' style={{ marginBottom: '30px' }}>
          <div className='media-left'>
            <PhotoWidget
              header='Icon'
              onChange={this.iconChange}
              image={entertainment.picture}
            />
          </div>
          <div className='media-body' style={{ paddingTop: '15px' }}>
            <FormGroup>
              <ControlLabel>Title</ControlLabel>
              <FormControl
                onChange={this.titleChange}
                value={entertainment.title}
              />
            </FormGroup>
          </div>
        </div>
        <button
          type='button'
          className='btn btn-primary pull-right'
          disabled={!this.validate()}
          style={{ marginRight: '0px' }}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          onClick={this.createElement}
          aria-label='left Align'
        >
          {buttonText}
        </button>
        {!update && (
          <button
            type='button'
            className='btn btn-def pull-right'
            disabled={!this.validate()}
            style={{ marginRight: '25px' }}
            onClick={this.createAndAddElse}
            aria-label='left Align'
          >
            Create and add else
          </button>
        )}
      </Fragment>
    );
  };

  renderDeleteMessage = () => (
    <div style={{ marginBottom: '40px' }}>
      Are you sure you want to delete this Entertainment?
    </div>
  );

  validate = () => {
    const { entertainment } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    return entertainment.picture.data && entertainment.title;
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { entertainments } = this.props;
    const {
      openModal,
      modalContent,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      modalAction,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      modalActionText,
    } = this.state;
    return (
      <Fragment>
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
          action={modalAction}
          actionButtonText={modalActionText}
        >
          {modalContent()}
        </Modal>
        <TopPanel>
          <h1
            className='col-md-6 col-sm-4 col-xs-3'
            style={{ marginTop: '0px' }}
          >
            In a Nutshell
          </h1>
        </TopPanel>
        <div className='data-container'>
          <button
            type='button'
            className='btn btn-primary pull-right panel-button'
            style={{ marginRight: '32px' }}
            onClick={this.create}
            aria-label='left Align'
          >
            + Add New
          </button>
          <div className='clearfix' />
          <div className='table-box tab-cont small-height'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {entertainments.length > 0 ? (
              <EntertainmentList
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                content={entertainments}
                deleteEntertainment={this.toDelete}
                updateEntertainment={this.toUpdate}
              />
            ) : (
              <h2>Entertainment list is empty</h2>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
